import axios from "axios";

// Определяем базовый URL в зависимости от окружения
// NODE_ENV автоматически устанавливается в 'development' при npm start и 'production' при npm run build
const getBaseURL = () => {
    if (process.env.NODE_ENV === 'development') {
        // return "http://127.0.0.1:4500"
        return "http://10.39.1.5:4500"
        // return "http://192.168.49.95:4500"
    }
    return "https://map2.infosys05.ru"
}

const baseURL = getBaseURL()

const $host = axios.create({
    baseURL: baseURL
})

const $authHost = axios.create({
    baseURL: baseURL
})

const authInterceptor = config => {
    config.headers.authorization = `Bearer ${localStorage.getItem('token')}`
    return config
}

// Интерцептор для обработки ошибок авторизации
const responseInterceptor = response => {
    return response
}

const errorInterceptor = error => {
    if (error.response?.status === 401) {
        // Если получаем 401 ошибку, удаляем токен
        localStorage.removeItem('token')
        // Можно также диспатчить logout action, но для этого нужно передать store
    }
    return Promise.reject(error)
}

$authHost.interceptors.request.use(authInterceptor)
$authHost.interceptors.response.use(responseInterceptor, errorInterceptor)

export {
    $host,
    $authHost
}